import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const MODULE_CONFIG = {
  '/login': {
    title: 'Petrol Pump Existing User Login',
    description: 'Open existing petrol pump user login module.',
    envUrl: process.env.REACT_APP_PETROL_EXISTING_LOGIN_URL || '',
    buttonLabel: 'Open Existing User Login',
  },
  '/register': {
    title: 'Petrol Pump New User Registration',
    description: 'Open new user registration for petrol pump management.',
    envUrl: process.env.REACT_APP_PETROL_NEW_USER_URL || '',
    buttonLabel: 'Open New User Registration',
  },
  '/car-service': {
    title: 'Car Service Module',
    description: 'Open car service software module.',
    envUrl: process.env.REACT_APP_CAR_SERVICE_URL || '',
    buttonLabel: 'Open Car Service',
  },
};

function openUrl(url) {
  if (!url) return;
  window.location.href = url;
}

export default function ModuleGateway() {
  const navigate = useNavigate();
  const location = useLocation();

  const cfg = MODULE_CONFIG[location.pathname] || {
    title: 'Module',
    description: 'Open selected module.',
    envUrl: '',
    buttonLabel: 'Open Module',
  };

  const defaultUrl = `${window.location.origin}/`;
  const targetUrl = cfg.envUrl || defaultUrl;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-indigo-900 to-slate-800 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-lg">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">{cfg.title}</h1>
        <p className="text-gray-600 mb-5">{cfg.description}</p>

        <div className="space-y-3">
          <button
            type="button"
            onClick={() => openUrl(targetUrl)}
            className="w-full py-3 rounded-xl font-semibold text-white bg-indigo-600 hover:bg-indigo-700 transition"
          >
            {cfg.buttonLabel}
          </button>

          <button
            type="button"
            onClick={() => navigate('/')}
            className="w-full py-3 rounded-xl font-semibold text-indigo-700 bg-indigo-100 hover:bg-indigo-200 transition"
          >
            Back To Business Home
          </button>
        </div>

        {!cfg.envUrl && (
          <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-2.5 mt-4">
            Note: Specific module URL is not configured in environment, so this button opens business home.
          </p>
        )}
      </div>
    </div>
  );
}
